<template>
  <b-form>
    <b-card>
      <b-card-text>
        <b-row>
          <b-col
            sm="12"
            md="6"
          ><h6 class="mb-1">
            İzin Tipi Ekle
          </h6></b-col>
        </b-row>
        <b-form-group label="Başlık">
          <b-form-input
            v-model="formData.title"
            placeholder="Başlık"
          />
        </b-form-group>
        <b-form-group label="Gün Sayısı">
          <cleave
            id="days"
            v-model="formData.days"
            class="form-control"
            :raw="false"
            :options="options.days"
            placeholder="Gün Sayısı"
          />
        </b-form-group>
        <b-form-group label="Ödeme">
          <cleave
            id="paid"
            v-model="formData.paid"
            class="form-control"
            :raw="false"
            :options="options.paid"
            placeholder="Ödeme"
          />
        </b-form-group>
        <b-form-group label="Yıllık">
          <cleave
            id="yearly"
            v-model="formData.yearly"
            class="form-control"
            :raw="false"
            :options="options.yearly"
            placeholder="Yıllık"
          />
        </b-form-group>
      </b-card-text>
    </b-card>
    <b-button
      variant="danger"
      :disabled="submitStatus"
      @click="submitForm"
    >
      Kaydet
    </b-button>
  </b-form>
</template>

<script>
import {
  BForm,
  BCard,
  BCardText,
  BFormInput,
  BFormGroup,
  BRow,
  BCol,
  BButton,
} from 'bootstrap-vue'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'

export default {
  name: 'Add',
  components: {
    BForm,
    BCard,
    BCardText,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BButton,
    Cleave,
  },
  data() {
    return {
      submitStatus: false,
      formData: {
        title: null,
        days: null,
        paid: null,
        yearly: null,
      },
      options: {
        days: {
          numeral: true,
          numeralThousandsGroupStyle: 'hundred',
        },
        paid: {
          numeral: true,
          numeralThousandsGroupStyle: 'hundred',
        },
        yearly: {
          numeral: true,
          numeralThousandsGroupStyle: 'hundred',
        },
      },
    }
  },
  computed: {
    saveStatus() {
      return this.$store.getters['permitTypes/getPermitTypeSaveStatus']
    },
  },
  watch: {
    saveStatus(val) {
      if (val.status === true) {
        this.formData = {
          title: null,
        }
        const config = {
          icon: 'success',
          title: 'İşlem Başarılı!',
          text: 'Kayıt işleminiz başarılı!',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      } else if (val.status === false) {
        const config = {
          icon: 'error',
          title: 'İşlem Hatası!',
          text: 'Kayıt işleminiz yapılamadı.! Lütfen tekrar deneyiniz.',
          html: null,
          buttonText: 'Kapat',
        }
        this.sweetAlert(config)
      }
      this.submitStatus = false
    },
  },
  created() {

  },
  methods: {
    sweetAlert(config) {
      this.$swal({
        icon: config.icon,
        title: config.title,
        text: config.text,
        html: config.html,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
        confirmButtonText: config.buttonText,
        buttonsStyling: false,
      })
    },
    submitForm() {
      this.submitStatus = true
      this.$store.dispatch('permitTypes/permitTypeSave', this.formData)
    },
  },
}
</script>
